import { useState } from "react";
import { _endPoints, getcustomers_by_name } from "../Helper/links";
import pattern from "../Helper/pattern";
import API from '../Helper/server/API';
export const useCustomer = () => {
  const [customers, setCustomers] = useState([]);
  const [customer, set_customer] = useState({
    ID_customer: null,
    id_user: "",
    city: { id_city: null, name_city: '' },
    visitor_name: "",
    phone_number: "",
    whatsapp_number: "",
    note: "",
    state: 1,
  })
  //_____________________________________________________________________
  const [id_customer, setid_customer] = useState("");
  const [visitor_name, setvisitor_name] = useState("");
  const [national_number, set_national_number] = useState("")
  const [phone_number, setphone_number] = useState("");
  const [whatsapp_number, setwhatsapp_number] = useState("");
  const [note, set_note] = useState("");
  const [city, set_city] = useState({ ID_city: null, name_city: "" });
  const [files, set_files] = useState([])
  const [state, set_state] = useState(0);
  const [verification, set_verification] = useState(false);

  //_____________________________________________________________________
  const handel_visitor_name = (e) => {
    setvisitor_name(e.target.value.toLowerCase())
    if ((pattern.name_en.test(e.target.value) === false && pattern.name_ar.test(e.target.value) === false) || e.target.value === "" || e.target.value.length > 200) {
      document.getElementById("lvisitor_name").style.color = 'red';
    }
    else {
      document.getElementById("lvisitor_name").style.color = 'black';
    }
  }
  const handel_national_number = (e) => {
    set_national_number(e.target.value.toLowerCase())
    if (e.target.value !== null && e.target.value !== '' && pattern.national_number.test(e.target.value) === false) {
      document.getElementById("lnational_number").style.color = 'red';
    }
    else {
      document.getElementById("lnational_number").style.color = 'black';
    }
  }
  const handel_phone_number = (e) => {
    setphone_number(e.target.value)
    if (pattern.phone_number.test(e.target.value) === false || e.target.value.toString().length !== 9) {
      document.getElementById("lphone_number").style.color = 'red';
    }
    else {
      document.getElementById("lphone_number").style.color = 'black';
    }
  }
  const handel_whatsapp_number = (value) => {
    if (value) {
      setwhatsapp_number(value)
      if (value.toString().length < 10 || value.toString().length > 15) {
        document.getElementById("lwhatsapp_number").style.color = 'red';
      }
      else {
        if (value.slice(0, 4) === '+218' && value.toString().length !== 13)
          document.getElementById("lwhatsapp_number").style.color = 'red';
        else
          document.getElementById("lwhatsapp_number").style.color = 'black';
      }
    }
  }
  const handel_note = (e) => {
    set_note(e.target.value.toLowerCase())
    if ((pattern.name_en.test(e.target.value) === false && pattern.name_ar.test(e.target.value) === false && e.target.value !== '') || e.target.value.length > 1000) {
      document.getElementById("lnote").style.color = 'red';
    }
    else {
      document.getElementById("lnote").style.color = 'black';
    }
  }
  const handel_files = (e) => {
    set_files(e.files)
  }
  const customer_clear = () => {
    setid_customer("");
    setvisitor_name("");
    setphone_number("")
    setwhatsapp_number("");
    set_city({ ID_city: null, name_city: "" });
    set_note("");
    set_national_number('')
    set_verification(false);
  }
  //_____________________________________________________________________
  const itemTemplate_filtered_customers = (item) => {
    return (
      <div className="row">
        <div className="col-6 col-md-6">   <p style={item.state === 0 ? { color: "red" } : null}>{item.visitor_name} </p></div>
        <div className="col-6 col-md-6">   <p style={item.state === 0 ? { color: "red" } : null}>{item.phone_number}</p></div>

      </div>
    )
  }
  const [filtered_customers, set_filtered_customers] = useState(null);
  const search_customer_by_name = async (event) => {
    if (event.query && event.query.length > 2) {
      var response = await API.get(_endPoints.customers.getcustomers_by_name + `?visitor_name=${event.query}`)
      if (response?.success === 500 || response?.error === 1) {

      }
      else if (response?.success === 1) {
        set_filtered_customers(response.customers);
      }
      else {
        set_filtered_customers([]);
      }
    }
    else {
      set_filtered_customers([]);
    }
  }
  const search_customer_by_phone = (event) => {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo purposes we filter at client side
    let query = event.query;
    let _filtered_customers = [];
    for (let i = 0; i < customers.length; i++) {
      let customer = customers[i];
      if (customer.phone_number.toString().toLowerCase().indexOf(query.toLowerCase()) === 0) {
        _filtered_customers.push(customer);
      }
    }
    set_filtered_customers(_filtered_customers);
  }
  const handelcustomer_by_name = (e) => {
    var have = false;
    if (e.target.value.ID_customer) {
      set_customer(e.target.value)
      setvisitor_name("")
      document.getElementById("lvisitor_name_search").style.color = 'black';
      have = true;
      return;
    }
    else {
      if (!have) {
        set_customer({
          ID_customer: null,
          id_user: "",
          city: { id_city: null, name_city: '' },
          visitor_name: "",
          phone_number: "",
          whatsapp_number: "",
          note: "",
          state: 1,
        })
        document.getElementById("lvisitor_name_search").style.color = 'red';

      }
      if ((e.target.value !== '' && e.target.value !== null && pattern.name_ar.test(e.target.value) === false && pattern.name_en.test(e.target.value) === false) || e.target.value.length > 255) {
        document.getElementById("lvisitor_name_search").style.color = 'red';
      }
      else {
        document.getElementById("lvisitor_name_search").style.color = 'black';
      }
      setvisitor_name(e.target.value)
    }
  }
  const handelcustomer_by_phone = (e) => {
    var have = false;
    if (e.target.value.ID_customer) {
      setid_customer(e.target.value.ID_customer)
      setvisitor_name(e.target.value.visitor_name)
      setphone_number(e.target.value.phone_number)
      setwhatsapp_number(e.target.value.whatsapp_number ? '+' + e.target.value.whatsapp_number : null)
      document.getElementById("lvisitor_name").style.color = 'black';
      document.getElementById("lphone_number").style.color = 'black';
      have = true;
      document.getElementById('msg_customer').innerHTML = "زبون مسجل مسبقا"
      return;
    }
    else {
      if (!have) {
        if (id_customer !== null && id_customer !== '') {
          setid_customer("");
          setvisitor_name("");
          setwhatsapp_number(null);
        }
      }
      if (pattern.phone_number.test(e.target.value) === false || e.target.value.length !== 9) {
        document.getElementById("lphone_number").style.color = 'red';
      }
      else {
        document.getElementById("lphone_number").style.color = 'black';
      }
      setphone_number(e.target.value)
      document.getElementById('msg_customer').innerHTML = "زبون جديد"
    }

  }

  const handel_city = (e) => {

    if (e.value && e.value.ID_city && e.value.name_city && pattern.number_int.test(e.value.ID_city)
      && (pattern.name_ar.test(e.value.name_city) || pattern.name_en.test(e.value.name_city))
    ) {
      set_city({
        ID_city: e.value.ID_city,
        name_city: e.value.name_city,
      })
      document.getElementById("lcity").style.color = 'black';
    }
    else {
      document.getElementById("lcity").style.color = 'red';
    }
  }
  return {
    id_customer, setid_customer, visitor_name, setvisitor_name, handel_visitor_name, national_number, set_national_number, handel_national_number, phone_number, setphone_number, handel_phone_number, whatsapp_number, setwhatsapp_number, handel_whatsapp_number, note, set_note, handel_note,
    city, set_city, customer_clear, filtered_customers, customer, set_customer, state, set_state, verification, set_verification,
    handel_city, handelcustomer_by_name, handelcustomer_by_phone, search_customer_by_name, search_customer_by_phone, setCustomers, set_filtered_customers, itemTemplate_filtered_customers
  }

}